// extracted by mini-css-extract-plugin
export default {"container":"File_container__YoCv5","file":"File_file__nTjCP","file__name":"File_file__name__0Ba7r"};